export enum TransitionTypes {
    APPEAR = "t--appear",
}
